// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tm-2";
export var container = "_tm-4";
export var dismissButton = "_tm-3";
export var hasPaddingBottom = "_tm-6";
export var last = "_tm-e";
export var scrollbarThumb = "_tm-c";
export var scrollbarTrack = "_tm-b";
export var selected = "_tm-9";
export var spin = "_tm-1";
export var spinning = "_tm-0";
export var suggestionItem = "_tm-d";
export var suggestionsPanel = "_tm-5";
export var tonePill = "_tm-8";
export var tonesContainer = "_tm-7";
export var unselected = "_tm-a";